<template>
  <iframe id="map-viewer" :src="urlWithToken" />
</template>

<script>
export default {
  name: 'MapViewerMapReport',

  props: {
    url: {
      type: String,
      required: true,
    },
  },

  computed: {
    urlWithToken() {
      const accessToken = localStorage.getItem('token')
      return `${this.url}/iframe?token=${accessToken}`
    },
  },
}
</script>

<style>
#map-viewer {
  width: 100%;
  height: 100%;
  border: none;
}
</style>
